import isTokenRegenerate from './isTokenRegenerate'

const responseToJson = (res, apiRoute, params) => {
	if (res.ok) {
		return res.json()
	}
	return isTokenRegenerate(res, apiRoute, params)
}

export default responseToJson